import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from '../../utils/history';

import { signIn } from '../../actions/user';

import BlankState from '../../components/BlankState';
import { TabHolder, Tab } from '../../components/Tabs';
import Page from '../../components/Page';
import StatusMessages from '../../components/StatusMessages';

import Register from './Register';
import ResetPassword from './ResetPassword';
import simpleReactValidator from 'simple-react-validator';
class Login extends Component {
  constructor(props) {
    super(props);
    this.validator = new simpleReactValidator();
    this.state = {
      user: {
        username: '',
        password: ''
      }
    };
  }

  onChange = e => {
    const { name, value } = e.target;
    const { user } = this.state;

    this.setState({
      user: {
        ...user,
        [name]: value
      }
    });
  };

  onFormSubmit = e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.validator.hideMessages();
      this.props.signIn(this.state.user);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const menuItems = [
      { id: 'login', name: 'Login', active: true },
      { id: 'register', name: 'Register' },
      { id: 'reset-password', name: 'Reset Password' }
    ];

    const { user } = this.props;

    if (user.userInfo) {
      history.push('/dashboard');
      window.location.reload();
    }

    return (
      <Page>
        <div className="clearfix auth-holder">
          <div className="col-sm-6 col-md-4 auth-forms card">
            <TabHolder menuItems={menuItems} tabsClass="clear-tabs">
              <Tab menuId={menuItems[0].id} isActive={true}>
                {user.error && !user.login_loading ? (
                  <StatusMessages
                    type="error"
                    message={user.errorMessage.error}
                  />
                ) : null}

                <BlankState
                  data={false}
                  customMessage="Logging in"
                  isDataLoading={user.login_loading}
                />

                <form className="form sign-in" onSubmit={this.onFormSubmit}>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    value={this.state.user.username}
                    onChange={this.onChange}
                    className="form-control"
                    placeholder="Username or Email Address"
                    required
                    autoFocus
                  />
                  {this.validator.message(
                    'username',
                    this.state.user.username,
                    'required',
                    'text-danger'
                  )}

                  <input
                    type="password"
                    name="password"
                    id="password"
                    value={this.state.user.password}
                    onChange={this.onChange}
                    className="form-control"
                    placeholder="Password"
                    required
                  />
                  {this.validator.message(
                    'password',
                    this.state.user.password,
                    'required',
                    'text-danger'
                  )}
                  <button
                    onClick={this.onFormSubmit}
                    className="btn btn-primary"
                  >
                    SIGN IN
                  </button>
                </form>
              </Tab>

              <Tab menuId={menuItems[1].id}>
                <Register />
              </Tab>

              <Tab menuId={menuItems[2].id}>
                <ResetPassword />
              </Tab>
            </TabHolder>
          </div>

          {/* <div className="col-sm-6 pull-right cover-img-holder hidden">
						<img src={ cover_img } className="img-responsive" />
						<div></div>
					</div> */}
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.user
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ signIn }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/pages/auth/Login.js